import { render, staticRenderFns } from "./UserFaq.vue?vue&type=template&id=207b032b&"
import script from "./UserFaq.vue?vue&type=script&lang=js&"
export * from "./UserFaq.vue?vue&type=script&lang=js&"
import style0 from "./UserFaq.vue?vue&type=style&index=0&id=207b032b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports